import Vue from 'vue'
import VueI18n from 'vue-i18n'

import pl from './pl'
import en from './en'

const messages = {
  pl,
  en,
}

Vue.use(VueI18n)

export default new VueI18n({
  locale: 'pl',
  messages,
})
